import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { Routes, RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { FirstTimeLoginComponent } from './first-time-login/first-time-login.component';
import { AuthGuard } from '../shared/security/auth.guard';
import { LoginErrorComponent } from './login-error/login-error.component';
import { EmailComponent } from './email/email.component';

const loginRoutes: Routes = [
  {path:'login',component:LoginComponent, data: { title: 'Please Login'}},
  { path: 'resetPassword', component: ResetPasswordComponent},
  { path: 'firstTimeLogin', component: FirstTimeLoginComponent, canActivate: [AuthGuard]},
  { path: 'loginError', component: LoginErrorComponent},
  { path: 'emailAddress', component: EmailComponent, canActivate: [AuthGuard]}

];


@NgModule({
  imports: [
    RouterModule.forChild(loginRoutes),
    CommonModule
  ],
  exports : [
    RouterModule
  ],
  declarations: []
})
export class LoginRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/login/login-routing.module.ts